(() => {
  document.querySelectorAll('[data-cookie-preferences]').forEach(button => {
    button.addEventListener('click', async () => {
      const status = button.parentElement.querySelector('[data-cookie-status]');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (status) status.hidden = true;
      try {
        // The native Shopify banner may still be loading on a fast first click.
        for (let attempt = 0; attempt < 20 && !window.privacyBanner?.showPreferences; attempt++) {
          await new Promise(resolve => setTimeout(resolve, 150));
        }
        if (!window.privacyBanner?.showPreferences) throw new Error('Privacy banner unavailable');
        await window.privacyBanner.showPreferences();
      } catch {
        if (status) {
          status.textContent = button.dataset.error;
          status.hidden = false;
        }
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
  });
})();
